/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonTableMessages } from '../messages/comparison-table';
export const ComparisonTableTranslations = merge(undefined, commonMessages, comparisonTableMessages);
